import { ReactElement } from 'react';
import { usePrevious } from 'react-use';

import { useFormController } from '@dreryk/react-common';

import { practitionersTranslationKeys } from '../../../../../translations';

import { DefaultConfidentialityModeUpdateModalOpener } from './defaultConfidentialityModeUpdate/modal/DefaultConfidentialityModeUpdateModal.opener';
import { DefaultConfidentialityModeSelect } from './DefaultConfidentialityModeCell.styled';
import { useTriggerLabelExtractor } from './DefaultConfidentialityModeCell.hooks';
import {
   DefaultConfidentialityModeFormBean,
   DefaultConfidentialityModeOption,
} from './DefaultConfidentialityModeCell.types';

const DEFAULT_CONFIDENTIALITY_MODE_OPTIONS: DefaultConfidentialityModeOption[] = ['NORMAL', 'CONFIDENTIAL'];

type DefaultConfidentialityModeCellProps = {
   readonly initialValue: DefaultConfidentialityModeOption;
   readonly practitionerId: number;
};

export const DefaultConfidentialityModeCell = (props: DefaultConfidentialityModeCellProps): ReactElement => {
   const { register, watch, reset } = useFormController<DefaultConfidentialityModeFormBean>({
      defaultConfidentialityMode: props.initialValue,
   });
   const triggerLabelExtractor = useTriggerLabelExtractor();
   const defaultConfidentialityMode = watch('defaultConfidentialityMode');
   const previousValue = usePrevious(defaultConfidentialityMode);

   const revertConfidentialityMode = (): void => {
      reset({ defaultConfidentialityMode: previousValue ?? props.initialValue });
   };

   return (
      <DefaultConfidentialityModeUpdateModalOpener
         mode={defaultConfidentialityMode}
         practitionerId={props.practitionerId}
         onCancel={revertConfidentialityMode}
      >
         {({ openModal }) => (
            <DefaultConfidentialityModeSelect<DefaultConfidentialityModeOption>
               testId={'defaultConfidentialityMode'}
               triggerLabelExtractor={triggerLabelExtractor}
               controller={register('defaultConfidentialityMode')}
               defaultValue={DEFAULT_CONFIDENTIALITY_MODE_OPTIONS[0]}
               onSelect={openModal}
               compact
            >
               <DefaultConfidentialityModeSelect.List items={DEFAULT_CONFIDENTIALITY_MODE_OPTIONS}>
                  {(item) => (
                     <DefaultConfidentialityModeSelect.Item
                        item={item}
                        testId={item}
                        label={practitionersTranslationKeys.defaultDataMode[item]}
                     />
                  )}
               </DefaultConfidentialityModeSelect.List>
            </DefaultConfidentialityModeSelect>
         )}
      </DefaultConfidentialityModeUpdateModalOpener>
   );
};
